export default __webpack_public_path__ + "static/media/11.e1462770.jpg";